namespace Matrix.Data {
    export interface DataReportEditorTypeItem {
        EditorType?: string;
        DisplayName?: string;
        Options?: Serenity.PropertyItem[];
    }
}
